module.exports = __webpack_public_path__ + "static/media/33.0e48b6a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/33.svg
// module id = 144
// module chunks = 0